import request from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';
/**
 * 删除客户负责人导入数据-rzq
 * @param {Object} params - 删除参数
 * @returns {Promise}
 */
export const deleteCustomerPersonResponsibleImport = (params) => {
    return request({
        url: apiCrmHost + '/resp/achievement/del',
        method: 'get',
        params
    });
};

// 模板下载-rzq
export const templateDownloadApi = (params) => {
    return request({
        url: apiCrmHost + '/common/template/download',
        method: 'get',
        responseType: 'blob',
        params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};

/**
 * 导入【收入】责任制数据初始化数据-xsh
 * @param {Object} params - 导入参数，包含URL和name
 * @returns {Promise}
 */
export const importRespDetailImport = (data) => {
    return request({
        url: apiCrmHost + '/resp/details/import',
        method: 'post',
        data
    });
};
// 【收入】责任制数据初始化导入模板下载-xsh
export const RespDetailtemplateDownloadApi = (params) => {
    return request({
        url: apiCrmHost + '/resp/details/file/download',
        method: 'get',
        responseType: 'blob',
        params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};

/**
 * 导入保存客户负责人数据-rzq
 * @param {Object} params - 导入参数，包含URL和name
 * @returns {Promise}
 */
export const importCustomerPersonResponsibleImport = (data) => {
    return request({
        url: apiCrmHost + '/resp/achievement/import',
        method: 'post',
        data
    });
};

/**
 * 下载导入删除模板-xsh
 * @returns {Promise}
 */
export const RespDetailDeltemplateDownloadApi = (params) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/fileDelete/download',
        method: 'post',
        responseType: 'blob',
        data: params
    }).then(res => {
        utils.downloadStream(res, params.fileName);
    });
};

// 模板下载-rzq
export const resTemplateDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/resp/dataManage/file/download',
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
        utils.downloadStream(res, data.fileName);
    });
};
